import { alpha } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import { svgIconClasses } from "@mui/material/SvgIcon";
//
import { paper, menuItem } from "../../css";
import React from "react";
import { ArrowDownIcon } from "../../../components/icons/ArrowDownIcon";
import { Box } from "@mui/material";
// ----------------------------------------------------------------------
export function autocomplete(theme) {
    return {
        MuiAutocomplete: {
            defaultProps: {
                popupIcon: (React.createElement(Box, { className: "autocomplete-popup-icon", sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.3s ease",
                    } },
                    React.createElement(ArrowDownIcon, null))),
                ChipProps: { size: "small", variant: "soft", color: 'primary' },
            },
            styleOverrides: {
                root: {
                    [`& span.${autocompleteClasses.tag}`]: Object.assign(Object.assign({}, theme.typography.subtitle2), { fontWeight: 500, height: 24, minWidth: 24, lineHeight: "24px", textAlign: "center", padding: theme.spacing(0, 0.75), color: theme.palette.primary.dark, borderRadius: theme.shape.borderRadius, backgroundColor: alpha(theme.palette.primary.main, 0.16) }),
                    [`& .${autocompleteClasses.tag} .MuiChip-label`]: {
                        maxWidth: "155px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1),
                    },
                    [`& .MuiAutocomplete-inputRoot .MuiAutocomplete-input`]: {
                        width: 0,
                        minWidth: "0px",
                    },
                },
                paper: Object.assign({}, paper({ theme, dropdown: true })),
                listbox: {
                    padding: 0,
                    [`& .${autocompleteClasses.option}`]: Object.assign({}, menuItem(theme)),
                },
                endAdornment: {
                    [`& .${svgIconClasses.root}`]: {
                        width: 18,
                        height: 18,
                    },
                    '& .MuiIconButton-root': {
                        width: 32,
                        height: 32,
                    },
                },
                popupIndicator: {
                    width: 32,
                    height: 32,
                    transition: "transform 0.3s ease",
                    [`&[aria-expanded="true"] .autocomplete-popup-icon`]: {
                        transform: "rotate(180deg)",
                    },
                },
                clearIndicator: {
                    width: 32,
                    height: 32,
                },
            },
        },
    };
}
